import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { observable, Observable, pipe } from 'rxjs';
import { BaseService } from './base.service.class';
import { NotificationService } from './notification.service';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DwhoPowerBiService extends BaseService {
  private dhoApiUrl = `${environment.urlBackend}/dhoapi`;
  private dwhoUrl = `${this.dhoApiUrl}/dwho`;

  constructor(
    private http: HttpClient,
    @Inject(LOCALE_ID) private locale: string,
    protected notificationService: NotificationService
  ) {
    super(notificationService);
  }

  getDwhoPowerBiUrl(managmentUnit: string): Observable<any> {
    const url = `${this.dwhoUrl}/power-bi-url/?managementUnit=${managmentUnit}`;

    return this.http.get<any>(url).pipe(
      tap((_) => {
        catchError(this.handleError<string>(`PowerBIUrl`));
      })
    );
  }
}
